module.exports = __webpack_public_path__ + "img/top.673b0edf.png";